import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function AdminDiscountCodes() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newCode, setNewCode] = useState({ code: '', discount_percent: 10 });

  useEffect(() => {
    fetchCodes();
  }, []);

  const fetchCodes = async () => {
    try {
      const response = await axios.get(API_URL + '/api/admin/discount-codes', {
        headers: { Authorization: 'Bearer ' + token }
      });
      setCodes(response.data.discount_codes || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const createCode = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_URL + '/api/admin/discount-codes', {
        code: newCode.code,
        discount_percent: parseInt(newCode.discount_percent)
      }, {
        headers: { Authorization: 'Bearer ' + token }
      });
      setShowModal(false);
      setNewCode({ code: '', discount_percent: 10 });
      fetchCodes();
    } catch (err) {
      alert('Failed to create code');
    }
  };

  const deleteCode = async (id) => {
    if (!window.confirm('Delete this code?')) return;
    try {
      await axios.delete(API_URL + '/api/admin/discount-codes/' + id, {
        headers: { Authorization: 'Bearer ' + token }
      });
      fetchCodes();
    } catch (err) {
      alert('Failed to delete');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900">
      <div className="bg-slate-800 border-b border-slate-700">
        <div className="max-w-7xl mx-auto px-4 py-6 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button onClick={function(){ navigate('/admin'); }} className="text-slate-400 hover:text-white">
              Back
            </button>
            <h1 className="text-2xl font-bold text-white">Discount Codes</h1>
          </div>
          <button 
            onClick={function(){ setShowModal(true); }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg"
          >
            Create Code
          </button>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid gap-4">
          {codes.map(function(code) {
            return (
              <div key={code.id} className="bg-slate-800 rounded-xl border border-slate-700 p-6 flex justify-between items-center">
                <div>
                  <h3 className="text-xl font-bold text-white font-mono">{code.code}</h3>
                  <p className="text-blue-400">{code.discount_percent}% OFF</p>
                  <p className="text-slate-500 text-sm">Uses: {code.times_used}</p>
                </div>
                <button 
                  onClick={function(){ deleteCode(code.id); }}
                  className="px-3 py-1 bg-red-500/20 text-red-400 rounded"
                >
                  Delete
                </button>
              </div>
            );
          })}
          {codes.length === 0 && (
            <p className="text-slate-500 text-center py-8">No discount codes</p>
          )}
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-slate-800 rounded-xl p-6 w-full max-w-md">
            <h2 className="text-xl font-bold text-white mb-4">Create Discount Code</h2>
            <form onSubmit={createCode}>
              <div className="mb-4">
                <label className="block text-slate-300 mb-2">Code</label>
                <input
                  type="text"
                  value={newCode.code}
                  onChange={function(e){ setNewCode({...newCode, code: e.target.value.toUpperCase()}); }}
                  className="w-full px-4 py-2 bg-slate-700 border border-slate-600 rounded text-white"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-slate-300 mb-2">Discount %</label>
                <input
                  type="number"
                  min="1"
                  max="100"
                  value={newCode.discount_percent}
                  onChange={function(e){ setNewCode({...newCode, discount_percent: e.target.value}); }}
                  className="w-full px-4 py-2 bg-slate-700 border border-slate-600 rounded text-white"
                  required
                />
              </div>
              <div className="flex gap-3">
                <button type="button" onClick={function(){ setShowModal(false); }} className="flex-1 py-2 bg-slate-700 text-white rounded">
                  Cancel
                </button>
                <button type="submit" className="flex-1 py-2 bg-blue-600 text-white rounded">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminDiscountCodes;
